import _ from 'lodash';
import { del, get, patch, post } from './agent';

const qbo = {
  public: {
    postRedirectUri: ({ uri }) => post('/qbo/redirect-uri', { uri }),
  },

  workspace:
    (workspacesUrl) =>
    (id = '') => {
      const url = _([workspacesUrl, 'qbo', id]).compact().join('/');

      return {
        getStatus: () => get(url.concat('/status')),
        getIntegration: () => get(url.concat('/integration')),
        remove: () => del(url.concat('/integration')),
        getConfiguration: () => get(url.concat('/configuration')),
        getConfigurationStatus: () => get(url.concat('/configuration/status')),
        updateConfiguration: (body) => patch(url.concat('/configuration'), body),
        setupConfiguration: () => post(url.concat('/setup/configuration')),
        getCompany: () => get(url.concat('/company')),
        getClients: () => get(url.concat('/clients')),
        getCustomers: () => get(url.concat('/customers')),
        getClientMappings: () => get(url.concat('/mapping/clients')),
        updateClientMappings: (body) => post(url.concat('/mapping/clients'), body),
        setupClients: () => post(url.concat('/setup/clients')),
        getItems: () => get(url.concat('/items')),
        getInvoiceItems: () => get(url.concat('/invoice-items')),
        getInvoiceItemMappings: () => get(url.concat('/mapping/invoice-items')),
        updateInvoiceItemMappings: (body) => post(url.concat('/mapping/invoice-items'), body),
        setupInvoiceItems: () => post(url.concat('/setup/invoice-items')),
        getQboPaymentMethods: () => get(url.concat('/qbo-payment-methods')),
        getPaymentMethods: () => get(url.concat('/payment-methods')),
        getPaymentMethodMappings: () => get(url.concat('/mapping/payment-methods')),
        updatePaymentMethodMappings: (body) => post(url.concat('/mapping/payment-methods'), body),
        setupPaymentMethods: () => post(url.concat('/setup/payment-methods')),
        getTaxRates: () => get(url.concat('/tax-rates')),
        getTaxCodes: () => get(url.concat('/tax-codes')),
        getTaxRateMappings: () => get(url.concat('/mapping/tax-rates')),
        updateTaxRateMappings: (body) => post(url.concat('/mapping/tax-rates'), body),
        setupTaxRates: () => post(url.concat('/setup/tax-rates')),
        setupMemberMappings: () => post(url.concat('/setup/members')),
        setupExpenseCategoryMappings: () => post(url.concat('/setup/expense-categories')),
        projects: {
          qbo: () => get(url.concat('/projects/qbo')),
          ruddr: () => get(url.concat('/projects/ruddr')),
        },
        getProjectMappings: () => get(url.concat('/mapping/projects')),
        updateProjectMappings: (body) => post(url.concat('/mapping/projects'), body),
        preferences: {
          projectsEnabled: () => get(url.concat('/preferences/projects-enabled')),
        },
        getDepositAccounts: () => get(url.concat('/deposit-accounts')),
        getMembers: () => get(url.concat('/members')),
        getVendors: () => get(url.concat('/vendors')),
        getExpenseCategories: () => get(url.concat('/expense-categories')),
        getExpenseAccounts: () => get(url.concat('/expense-accounts')),
        getMemberMappings: () => get(url.concat('/mapping/members')),
        updateMemberMappings: (body) => post(url.concat('/mapping/members'), body),
        getExpenseCategoryMappings: () => get(url.concat('/mapping/expense-categories')),
        updateExpenseCategoryMappings: (body) => post(url.concat('/mapping/expense-categories'), body),
        getSyncs: () => get(url.concat('/expenses/syncs')),
        getSyncLog: (id) => get(url.concat('/expenses/syncs/', id, '/log')),
        manualSync: () => post(url.concat('/expenses/manual-sync')),
      };
    },
};

export default qbo;
